var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { Icon, iconNames } from '@cb/apricot-react-icon';
import { Glyph, glyphNames } from '@cb/apricot-react-glyph';
/**
 * miscellaneous Divider element
 */
export const Divider = () => React.createElement("li", { role: "separator", className: "cb-divider" });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIcon = (x) => iconNames.includes(x);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGlyph = (x) => glyphNames.includes(x);
/**
 * Dropdown Item - supposed to be inside the Dropdown element
 */
const DropdownItem = (_a) => {
    var { dropdownItemId, disabled, onClick, iconLeft, icon = null, label, divider, selected } = _a, props = __rest(_a, ["dropdownItemId", "disabled", "onClick", "iconLeft", "icon", "label", "divider", "selected"]);
    /**
     * Default Item on click event handler - check the prop and call the callback if given
     */
    const onItemClick = e => {
        e.preventDefault();
        onClick && onClick();
    };
    const IconComponent = (isIcon(icon) && React.createElement(Icon, { decorative: true, name: icon })) ||
        (!isIcon(icon) && isGlyph(icon) && React.createElement(Glyph, { decorative: true, name: icon }));
    return divider ? (React.createElement(Divider, null)) : (React.createElement("li", { role: "presentation", className: cn(disabled && 'cb-disabled') },
        React.createElement("a", Object.assign({ id: dropdownItemId, role: "menuitem", href: "/#", "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? -1 : undefined, onClick: onItemClick, className: cn(selected && 'cb-selected') }, props),
            iconLeft && icon && (typeof icon === 'string' ? IconComponent : icon),
            label,
            !iconLeft && icon && (typeof icon === 'string' ? IconComponent : icon))));
};
export default DropdownItem;
//# sourceMappingURL=DropdownItem.js.map